import { render, staticRenderFns } from "./DepositActionDialog.vue?vue&type=template&id=208fd27f&scoped=true"
import script from "./DepositActionDialog.vue?vue&type=script&lang=js"
export * from "./DepositActionDialog.vue?vue&type=script&lang=js"
import style0 from "./DepositActionDialog.vue?vue&type=style&index=0&id=208fd27f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fd27f",
  null
  
)

export default component.exports